import { useRecoilValue, useSetRecoilState } from "recoil";
import { loginState } from "../../stores/loginState";
import { useMutation } from "react-query";
import {
  HandexInstance,
  HanjinInstance,
  KpcInstance,
  LogenInstance,
  LotteInstance,
} from "../instance";
import { calendarDataState } from "../../stores/calendar/calendarDataState";
import { isKpcCompany, normalizeKpcCalendarData } from "../../utils/kpc";

// TODO 월간 데이터 조회 API
const useGetCalenderData = (date) => {
  // NOTE 상태 변수
  const login = useRecoilValue(loginState); // 로그인 전역변수
  const setCalendarData = useSetRecoilState(calendarDataState); // 월간 데이터 전역변수

  // TODO API 결과
  const mutationOptions = {
    // 성공 시
    onSuccess: (data) => {
      if (data.result === "00" || data.result === "77") {
        // KPC 일별 통계 필드를 기존 달력 공통 필드로 변환한다.
        setCalendarData(
          isKpcCompany(login.company)
            ? normalizeKpcCalendarData(data.data)
            : data.data,
        );
      }
    },
    // 실패 시
    onError: (error) => {
      console.log(error);
    },
  };

  const [year, month] = date.split("-").slice(0, 2); // 연, 월 변수
  const postData = {
    bran_cd: login.branchCode,
    year: year,
    month: month,
  };

  let mutationFn;

  // TODO API 리퀘스트 정보
  if (login.company === "LOGEN") {
    mutationFn = () => LogenInstance.post("/calendar-data", postData);
  } else if (login.company === "LOTTE") {
    mutationFn = () => LotteInstance.post("/calendar-data", postData);
  } else if (login.company === "HANJIN") {
    mutationFn = () => HanjinInstance.post("/calendar-data", postData);
  } else if (login.company === "HANDEX") {
    mutationFn = () => HandexInstance.post("/calendar-data", postData);
  } else if (login.company === "KPC") {
    // KPC는 세션 점소로 권한을 판별하므로 bran_cd 없이 연·월만 전송한다.
    mutationFn = () => KpcInstance.post("/calendar-data", { year, month });
  } else {
    mutationFn = () => {
      throw new Error("Invalid company");
    };
  }

  return useMutation("getAmount", mutationFn, mutationOptions);
};

export default useGetCalenderData;
